import React, { useState, useEffect } from 'react';
import xor from 'lodash/xor';
import isEmpty from 'lodash/isEmpty';
import { EMPTY_MESSAGE_NO_RECORDS_FOR_THIS_PERIOD } from '@creditflowresearch/uilib/Table/DataTable/constants';
import styles from './sections.module.scss';

interface IProps {
  isFetching?: boolean,
  isOpen?: boolean,
  items?: {},
  isFilterChecked?: () => boolean,
  handleParentFilterChange?: () => void,
  toggleParentFilter?: () => void,
  handleFilterByChange?: () => void,
  handleFilterUpdate?: () => void,
  filtersTitleMapping?: {},
  filtersComponentsMapping?: {},
}

const Sections = ({
  isFetching = false,
  isOpen,
  items = {},
  isFilterChecked,
  handleParentFilterChange,
  toggleParentFilter,
  handleFilterByChange,
  handleFilterUpdate,
  filtersTitleMapping,
  filtersComponentsMapping,
}: IProps) => {
  const [hiddenSections, setHiddenSections] = useState<string[]>([]);

  useEffect(() => {
    if (!isOpen) {
      setHiddenSections([]);
    }
  }, [isOpen]);

  const isZerocase = () => {
    return !Object.keys(items).length && !isFetching;
  };

  const handleSectionToggle = (activeKey: string) => {
    setHiddenSections((prevHiddenSections) => xor(prevHiddenSections, [activeKey]));
  };

  if (isZerocase()) {
    return <div className={ styles.zerocase }>{ EMPTY_MESSAGE_NO_RECORDS_FOR_THIS_PERIOD }</div>;
  }

  if (!isEmpty(items)) {
    return Object.keys(filtersComponentsMapping).reduce((acc, key) => {
      if (key in items && items[key] && Object.keys(items[key]).length) {
        const isVisible = !hiddenSections.includes(key);
        acc.push(
          React.createElement(filtersComponentsMapping[key].component, {
            ...filtersComponentsMapping[key].componentProps,
            key,
            sectionId: key,
            sectionTitle: filtersTitleMapping[key],
            isVisible,
            onSectionToggle: handleSectionToggle,
            items: items[key],
            isFilterChecked,
            handleParentFilterChange,
            toggleParentFilter,
            handleFilterByChange,
            handleFilterUpdate,
          }),
        );
      }
      return acc;
    }, []);
  }

  return null;
};

export default Sections;
